export const SET_ERROR = 'error/SET_ERROR';
export const SET_UNKNOWN_ERROR = 'error/SET_UNKNOWN_ERROR';
export const SET_CONFIRM = 'error/SET_CONFIRM';
export const CLEAR_ERRORS = 'error/CLEAR_ERRORS';
